import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import OrderController from "../../controller/OrderController";
import {
  CurrentStoreType,
  authState,
  authType,
  currentStoreState,
  versionState,
} from "../../recoil/auth";
import {
  APP_NAME_KNOCKKNOCK,
  APP_NAME_THROO,
  KnockOrderItemType,
  ORDER_CANCLE_STATUS,
  ORDER_READY_STATUS,
  ORDER_WAIT_STATUS,
  OrderChildType,
  OrderItemType,
  OrderType,
  THROO_ORDER_STATE_COLOR,
  paymentRealmType,
} from "../../recoil/type";
import { getDecryptObject } from "../../utils/crypto";
//import ThrooOrder from "../order/ThrooOrder";
//import OwnOrder from "../order/OwnOrder";
import moment from "moment-timezone";
import { getRecoil, setRecoil } from "recoil-nexus";
import SoundControl from "../../components/SoundControl";
import DeliverySettingModal from "../../components/modal/DeliverySettingModal";
import ExceedModal from "../../components/modal/ExceedModal";
import PushSettingModal from "../../components/modal/PushSettingModal";
import RiderProgressModal from "../../components/modal/RiderProgressModal";
import LogController from "../../controller/LogController";
import PrinterController from "../../controller/PrinterController";
import { useToast } from "../../controller/ToastController";
import { ExceedType, exceedState } from "../../recoil/exceed";
import { noticeState, unreadCountState } from "../../recoil/notice";
import { PushSettingType, pushSettingState } from "../../recoil/sound";
import AsyncLocalStorage from "../../utils/AsyncLocalStorage";
import {
  completeOrderState,
  completeOrderType,
  loginState,
  newOrderState,
  newOrderType,
  notCompleteOrderState,
  notCompleteOrderType,
  updateBarogoState,
  updateBarogoType,
} from "../socket/socketState";
import Header from "./HomeComponent/Header";
import OrderList from "./HomeComponent/OrderList";
import SideBar from "./HomeComponent/SideBar";
import StatusTab from "./HomeComponent/StatusTab";
import { HomeStyle } from "./HomeStyle";
import NoticeController from "../../controller/NoticeController";
// import { noticeState } from "../../recoil/notice";

let cancelTimer: any;

const OrderLinkMain = () => {
  const navigate = useNavigate();

  const newOrderFlag = useRecoilValue<newOrderType>(newOrderState);
  const completeOrderFlag =
    useRecoilValue<completeOrderType>(completeOrderState);
  const notCompleteOrderFlag = useRecoilValue<notCompleteOrderType>(
    notCompleteOrderState
  );
  const updateBarogoFlag = useRecoilValue<updateBarogoType>(updateBarogoState);

  const showToast = useToast();

  const [exceed, setExceed] = useRecoilState<ExceedType>(exceedState);

  const [auth, setAuth] = useRecoilState<authType>(authState);

  const [version, setVersion] = useRecoilState<string>(versionState);

  const currentStore = useRecoilValue<CurrentStoreType>(currentStoreState);

  const unreadCount = useRecoilValue<number>(unreadCountState);

  //0: 접수대기 , 1:처리중 , 2:완료/취소
  const [status, setStatus] = useState<number>(1);
  //자세히 보기
  const [isDetail, setIsDetail] = useState<boolean>(
    AsyncLocalStorage.getItem("detailSetting")
      ? AsyncLocalStorage.getItem("detailSetting").is_detail
      : true
  );
  const [isOpenCongestion, setIsOpenCongestion] = useState<boolean>(false);
  const [isLoggedIn, set_isLoggedIn] = useState<boolean>(false);

  const [congestion, setCongestion] = useState<number>(0);

  //접수대기
  const [preparedList, setPreparedList] = useState<OrderItemType[]>([]);
  //처리중
  const [checkedList, setCheckedList] = useState<OrderItemType[]>([]);
  //완료/취소
  const [completedList, setCompletedList] = useState<OrderItemType[]>([]);

  const [completeStatus, setCompleteStatus] = useState<number>(0);

  // siderBar
  const [isOpenBar, setIsOpenBar] = useState<boolean>(false);
  // const [isAvailable, setIsAvailable] = useState<boolean>(true);

  const [visibleRiderProgress, setVisibleRiderProgress] =
    useState<boolean>(false);
  const [visibleDeliverySetting, setVisibleDeliverySetting] =
    useState<boolean>(false);
  const [visiblePushSetting, setVisiblePushSetting] = useState<boolean>(false);

  // sound
  const [pushSetting, setPushSetting] =
    useRecoilState<PushSettingType>(pushSettingState);

  const [isNew, setIsNew] = useState<boolean>(false);

  const location = useLocation();

  const itemRefs = useRef<(HTMLDivElement | null)[]>([]);

  const scrollToItem = () => {
    const itemRef = itemRefs.current[getRecoil(exceedState).index];

    if (itemRef) {
      console.log("itemRef", itemRef);
      itemRef.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
    setExceed({ ...exceed, isOpen: false });
  };

  // 자세히보기, 간략히 toggle버튼
  const viewTypeToggle = async () => {
    await AsyncLocalStorage.setItem(
      "detailSetting",
      JSON.stringify({ is_detail: !isDetail })
    );
    setIsDetail(!isDetail);
  };
  // 사이드바 toggle
  const viewAvailableToggle = () => {
    // setIsAvailable(!isAvailable);
  };

  const onChange_congestion = (value: number) => {
    setCongestion(value);
    setIsOpenCongestion(false);
  };

  const refreshAllOrder = async (isComplete: number, bIsMuted?: boolean) => {
    if (getRecoil(authState).refresh_token.length > 0 && isLoggedIn) {
      console.log("refresh");
      if (isComplete > 1) {
        let completedOrders = await OrderController.getCompleteOrderList();
        // console.log("getCompleteOrderList", completedOrders);
        if (completedOrders) {
          getCompleteOrder(completedOrders);
        }
      }
      let orders = await OrderController.getNotCompleteOrderList();
      // console.log("getNotCompleteOrderList", orders);
      if (orders) {
        // console.log("allOrder", orders, orders.length);
        divideOrderList(orders, bIsMuted);
      }

      let bHasWaitingOrders: boolean = false;
      if (orders && orders.length > 0) {
        orders.map((order) => {
          if (order.app_name === APP_NAME_KNOCKKNOCK) {
            order.child.map((item: OrderChildType) => {
              if (item.order_status === ORDER_WAIT_STATUS) {
                bHasWaitingOrders = true;
              }
            });
          }
        });
      }
    }
  };

  const getCompleteOrder = (oOrderList: any) => {
    const completedTemp: OrderItemType[] = [];

    if (oOrderList && oOrderList.length > 0) {
      oOrderList.map((order: OrderType) => {
        if (order.app_name === APP_NAME_KNOCKKNOCK) {
          order.child.map((item: OrderChildType) => {
            // if (item.delivery_type === 1) {
            const orderItem: KnockOrderItemType = {
              app_name: APP_NAME_KNOCKKNOCK,
              store_name: order.store_name,
              order_id: order.order_id,
              parent_store_id: order.parent_store_id,
              store_id: order.store_id,
              table_area_nr: order.table_area_nr,
              table_nr: order.table_nr,
              child: item,
              payment: order.payment
                ? order.payment.filter((iPayment: paymentRealmType) => {
                    return iPayment.order_id === order.order_id;
                  })
                : [],
              delivery_info: order.deliveryInfo,
            };
            // if (
            //   orderItem.child.order_status === ORDER_COM_STATUS ||
            //   orderItem.child.order_status === ORDER_CANCLE_STATUS ||
            //   orderItem.child.order_status === ORDER_COM_DEL_STATUS
            // ) {
            completedTemp.push(orderItem);
            // }
            // }
          });
        } else if (order.app_name === APP_NAME_THROO) {
          completedTemp.push(order);
        }
      });
      setCompletedList([...completedTemp]);
    }
  };

  const divideOrderList = (oOrderList: OrderType[], bIsMuted?: boolean) => {
    const preparedTemp: OrderItemType[] = [];
    const checkedTemp: OrderItemType[] = [];
    let iUnConfirmedOrderCount = 0;

    if (oOrderList && oOrderList.length > 0) {
      oOrderList.map((order) => {
        if (order.app_name === APP_NAME_KNOCKKNOCK) {
          order.child.map((item: OrderChildType) => {
            // if (item.delivery_type === 1) {
            // test

            const orderItem: KnockOrderItemType = {
              app_name: order.app_name,
              store_name: order.store_name,
              order_id: order.order_id,
              parent_store_id: order.parent_store_id,
              store_id: order.store_id,
              table_area_nr: order.table_area_nr,
              table_nr: order.table_nr,
              child: item,
              payment: order.payment
                ? order.payment.filter((iPayment: paymentRealmType) => {
                    return iPayment.order_id === order.order_id;
                  })
                : [],
              delivery_info: order.deliveryInfo,
            };
            if (orderItem.child.order_status === ORDER_WAIT_STATUS) {
              // if (
              //   currentStore.value &&
              //   currentStore.value.auto_confirmed === 1
              // ) {
              //   updateStatus(orderItem);
              // } else {
              preparedTemp.push(orderItem);
              // }
            }
            // 접수 전 출력
            if (newOrderFlag.order_id === orderItem.order_id) {
              console.log("print new order", orderItem);
              setRecoil(newOrderState, { ...newOrderFlag, order_id: "" });
              PrinterController.preparePrintData(orderItem, 0, true, true);
              LogController.print({
                path: "newOrder Queue",
                params: "새 주문 출력",
                params2: newOrderFlag.order_id,
              });
            }
            if (
              notCompleteOrderFlag.order_status === ORDER_READY_STATUS &&
              notCompleteOrderFlag.order_id === orderItem.order_id &&
              notCompleteOrderFlag.user_token_id !== auth.user_token_id &&
              !notCompleteOrderFlag.is_print
            ) {
              // 자동접수
              setRecoil(notCompleteOrderState, {
                date: new Date().getTime().toString(),
                order_status: 0,
                order_id: "",
                user_token_id: 0,
                is_update: true,
                is_print: true,
              });
              console.log(
                "print!!!",
                orderItem.order_id,
                notCompleteOrderFlag.order_id,
                notCompleteOrderFlag.user_token_id,
                auth.user_token_id
              );
              PrinterController.preparePrintData(orderItem, 2, true, true);
              LogController.print({
                path: "changeOrder Queue",
                params: "자동접수 출력",
                params2: notCompleteOrderFlag.order_id,
              });
            }
            // if (
            //   orderItem.child.order_status !== ORDER_COM_STATUS &&
            //   orderItem.child.order_status !== ORDER_CANCLE_STATUS
            //   // && orderItem.child.order_status !== ORDER_COM_DEL_STATUS
            // ) {
            checkedTemp.push(orderItem);
            // }
            // }
          });
        } else if (order.app_name === APP_NAME_THROO) {
          if (
            [
              THROO_ORDER_STATE_COLOR.STANDBY,
              THROO_ORDER_STATE_COLOR.CONFIRMED,
              THROO_ORDER_STATE_COLOR.PREPARED,
            ].indexOf(order.state_color) !== -1
          ) {
            if (currentStore.value && currentStore.value.auto_confirmed === 1) {
              //TODO 스루 자동 접수시 로직 필수
              // updateStatus(orderItem);
            } else {
              preparedTemp.push(order);
            }

            checkedTemp.push(order);
          }
        }
      });
    }

    if (preparedTemp.length > 0) {
      iUnConfirmedOrderCount = preparedTemp.length;
    } else if (bIsMuted !== undefined && !bIsMuted) {
      SoundControl.stopSound();
      window.parent.postMessage(
        JSON.stringify({
          action: "audio",
          data: {
            type: "audio",
            audio: pushSetting.effect,
            volume: pushSetting.volume,
            count: 0,
            audio_delay: pushSetting.delay,
            play_status: false,
          },
        }),
        "*"
      );
    }

    if (!bIsMuted) {
      // if (
      //   checkedTemp[0].app_name === APP_NAME_KNOCKKNOCK &&
      //   checkedTemp[0].child.order_status === ORDER_WAIT_STATUS
      // ) {
      //   SoundControl.init();
      //   SoundControl.playSound();
      // }
      // else {
      //   console.log("playSound01");
      //   SoundControl.playSoundOnce();
      //   SoundControl.stopSound();
      // }
    }

    if (window && window.parent) {
      window.parent.postMessage(
        JSON.stringify({
          action: "widget_neworder",
          data: { new_order: iUnConfirmedOrderCount },
        }),
        "*"
      );
    }

    setPreparedList([...preparedTemp]);
    setCheckedList([...checkedTemp]);
  };

  const handleIframeMessages = async (event: any) => {
    // console.log("orderlinkweb > Home.tsx handleIframMessages event.data", event.data);
    if (event && event.data) {
      let oMsg;
      try {
        // console.log("orderlinkweb > Home.tsx oMsg.action", event);
        oMsg = JSON.parse(event.data);
      } catch (error) {}
      if (oMsg) {
        console.log(
          "orderlinkweb > Home.tsx oMsg.action",
          oMsg.action,
          oMsg.action === "set_auth"
        );
        if (oMsg.action && oMsg.action === "set_auth") {
          let oUserData = getDecryptObject(oMsg.data);
          console.log("orderlinkweb >>> oUserData", oUserData);
          if (oUserData.type === "set_auth") {
            setAuth(oUserData.data);

            if (oUserData.version) {
              setVersion(oUserData.version);
            }
            setTimeout(() => {
              setRecoil(authState, oUserData.data);
              if (oUserData.version) {
                setRecoil(versionState, oUserData.version);
              }
              setRecoil(loginState, new Date().getTime().toString());

              const hideTemp = AsyncLocalStorage.getItem("hide");

              if (
                (!hideTemp ||
                  (hideTemp &&
                    !moment(hideTemp).isSame(
                      moment(new Date()).format("YYYY/MM/DD")
                    ))) &&
                unreadCount > 0
              ) {
                setRecoil(noticeState, true);
              }
              set_isLoggedIn(true);
              console.log("login!");
            }, 500);
          }
        }
        // else if (oMsg.action && oMsg.action === "refresh_state") {
        //   if (
        //     getRecoil(authState).refresh_token &&
        //     getRecoil(authState).refresh_token.length > 0
        //   ) {
        //     refreshAllOrder(2, true);
        //   }
        // }
      }
    }
  };

  const webLoginCheck = () => {
    let sWebLogin = AsyncLocalStorage.getItem("webBrowserLogin");
    console.log("sWebLogin", sWebLogin);
    if (sWebLogin === true) {
      set_isLoggedIn(true);
      //AsyncLocalStorage.removeItem("webBrowserLogin");
    }
  };

  const cancelAudio = new Audio(
    `${process.env.PUBLIC_URL}/knockknock/audio/error_bell.mp3`
  );

  const playCancelAudio = () => {
    if (cancelAudio) {
      cancelTimer = setTimeout(() => {
        cancelAudio.currentTime = 0;
        cancelAudio.play();
      }, 5000);
    }
  };

  const getUnreadCount = async () => {
    try {
      if (
        getRecoil(authState).refresh_token.length > 0 &&
        getRecoil(currentStoreState).value
      ) {
        const oParams = {
          store_id: getRecoil(currentStoreState).value?.store_id,
        };
        const oRes = await NoticeController.getUnreadCount(oParams);

        if (oRes && oRes.data) {
          const oResponse = oRes.data;
          console.log("getUnreadCount", oResponse);
          if (oResponse.data) {
            setRecoil(unreadCountState, oResponse.data.unreadCount);
          }
        }
      }
    } catch (err) {
      console.log("err---->", err);
    }
  };

  useEffect(() => {
    if (currentStore.value && isLoggedIn) {
      getUnreadCount();
    }
  }, [currentStore, isLoggedIn]);

  useEffect(() => {
    if (exceed.isOpen) {
      if (getRecoil(versionState).length === 0) {
        if (cancelAudio) {
          cancelAudio.currentTime = 0;
          cancelAudio.play();
        }
      } else {
        window.parent.postMessage(
          JSON.stringify({
            action: "audio",
            data: {
              type: "exceed",
              audio: `${process.env.PUBLIC_URL}/knockknock/audio/error_bell.mp3`,
              volume: getRecoil(pushSettingState).volume,
              count: 10000,
              audio_delay: 5,
              play_status: true,
            },
          }),
          "*"
        );
      }

      cancelAudio.addEventListener("ended", playCancelAudio);
    } else {
      clearTimeout(cancelTimer);
      cancelTimer = null;
      window.parent.postMessage(
        JSON.stringify({
          action: "audio",
          data: {
            type: "exceed",
            audio: `${process.env.PUBLIC_URL}/knockknock/audio/error_bell.mp3`,
            volume: getRecoil(pushSettingState).volume,
            count: 0,
            audio_delay: 5,
            play_status: false,
          },
        }),
        "*"
      );
    }
    return () => {
      cancelAudio.removeEventListener("ended", playCancelAudio);
    };
  }, [exceed]);

  useEffect(() => {
    if (process.env.REACT_APP_ENV === "DEV") {
      webLoginCheck();
    }
    if (location && location.state && location.state.refreshOrder) {
      console.log("refresh");
      if (getRecoil(authState).refresh_token.length > 0) {
        refreshAllOrder(2, true);
      }
    }
  }, []);

  useEffect(() => {
    if (getRecoil(authState).refresh_token.length > 0 && isLoggedIn) {
      refreshAllOrder(2, true);
    }
  }, [auth.refresh_token, isLoggedIn]);

  useEffect(() => {
    if (getRecoil(authState).refresh_token.length > 0 && isLoggedIn) {
      if (!newOrderFlag.is_update && newOrderFlag.order_id) {
        console.log("new");

        let interval: NodeJS.Timeout;
        refreshAllOrder(0, false);
        setRecoil(newOrderState, {
          ...newOrderFlag,
          is_update: true,
        });
        setIsNew(true);
        if (getRecoil(versionState).length === 0) {
          SoundControl.init();
          SoundControl.playSound();
        } else {
          window.parent.postMessage(
            JSON.stringify({
              action: "audio",
              data: {
                type: "order",
                audio: getRecoil(pushSettingState).effect,
                volume: getRecoil(pushSettingState).volume,
                count: getRecoil(pushSettingState).orderCount,
                audio_delay: getRecoil(pushSettingState).delay,
                play_status: true,
              },
            }),
            "*"
          );
        }
        interval = setInterval(() => {
          clearInterval(interval);
          setIsNew(false);
        }, 10000);
      }
    }
  }, [newOrderFlag]);

  useEffect(() => {
    if (getRecoil(authState).refresh_token.length > 0 && isLoggedIn) {
      if (!completeOrderFlag.is_update) {
        console.log(
          "~~~~~~~~~~~~~~~~CompleteOrderFlag~~~~~~~~~~~~~~~~~~",
          completeOrderFlag
        );
        if (completeOrderFlag.order_status === ORDER_CANCLE_STATUS) {
          if (getRecoil(versionState).length === 0) {
            SoundControl.init();
            SoundControl.playSoundOnce();
          } else {
            window.parent.postMessage(
              JSON.stringify({
                action: "audio",
                data: {
                  type: "cancel",
                  audio: `${process.env.PUBLIC_URL}/knockknock/audio/error_bell.mp3`,
                  volume: getRecoil(pushSettingState).volume,
                  count: 1,
                  audio_delay: getRecoil(pushSettingState).delay,
                  play_status: true,
                },
              }),
              "*"
            );
          }
          refreshAllOrder(2, true);
        } else {
          refreshAllOrder(2, false);
        }
        setRecoil(completeOrderState, {
          ...completeOrderFlag,
          order_status: 0,
          is_update: true,
        });
      }
    }
  }, [completeOrderFlag]);

  useEffect(() => {
    if (getRecoil(authState).refresh_token.length > 0 && isLoggedIn) {
      if (!notCompleteOrderFlag.is_update) {
        console.log("~~~~~~~~~~~~~~~~notCompleteOrderFlag~~~~~~~~~~~~~~~~~~");
        refreshAllOrder(0, false);

        const newUpdatedItem = checkedList.find(
          (item) => item.order_id === notCompleteOrderFlag.order_id
        );

        if (
          !newUpdatedItem &&
          currentStore.value &&
          currentStore.value.auto_confirmed === 1 &&
          notCompleteOrderFlag.order_status === ORDER_READY_STATUS
        ) {
          if (getRecoil(versionState).length === 0) {
            SoundControl.init();
            SoundControl.playSoundOnce();
          } else {
            window.parent.postMessage(
              JSON.stringify({
                action: "audio",
                data: {
                  type: "auto_confirmed",
                  audio: getRecoil(pushSettingState).effect,
                  volume: getRecoil(pushSettingState).volume,
                  count: 1,
                  audio_delay: getRecoil(pushSettingState).delay,
                  play_status: true,
                },
              }),
              "*"
            );
          }
        }
        setRecoil(notCompleteOrderState, {
          ...notCompleteOrderFlag,
          is_update: true,
        });
      }
    }
  }, [notCompleteOrderFlag]);

  useEffect(() => {
    if (getRecoil(authState).refresh_token.length > 0 && isLoggedIn) {
      if (!updateBarogoFlag.is_update) {
        console.log(
          "~~~~~~~~~~~~~~~~updateBarogoFlag~~~~~~~~~~~~~~~~~~",
          updateBarogoFlag
        );
        refreshAllOrder(2, false);
        setRecoil(updateBarogoState, {
          ...completeOrderFlag,
          is_update: true,
        });
      }
    }
  }, [updateBarogoFlag]);

  useEffect(() => {
    document.addEventListener("message", handleIframeMessages);
    window.addEventListener("message", handleIframeMessages);

    if (window && window.parent) {
      window.parent.postMessage(
        JSON.stringify({
          action: "login",
          data: "",
        }),
        "*"
      );
    }

    return () => {};
  }, []);

  useEffect(() => {
    if (visiblePushSetting) console.log("open push setting");
  }, [visiblePushSetting]);

  return (
    <>
      <HomeStyle>
        <div className="wrap">
          <Header
            setIsOpenBar={setIsOpenBar}
            isOpenBar={isOpenBar}
            setVisiblePushSetting={setVisiblePushSetting}
            isOpenCongestion={isOpenCongestion}
            setIsOpenCongestion={setIsOpenCongestion}
            congestion={congestion}
            onChange_congestion={onChange_congestion}
            isDetail={isDetail}
            viewTypeToggle={viewTypeToggle}
            auth={auth}
            refreshAllOrder={refreshAllOrder}
          />
          <SideBar
            setIsOpenBar={setIsOpenBar}
            isOpenBar={isOpenBar}
            // isAvailable={isAvailable}
            viewAvailableToggle={viewAvailableToggle}
            navigate={navigate}
            refreshAllOrder={refreshAllOrder}
            preparedList={preparedList}
            isLoggedIn={isLoggedIn}
          />
          <div className={"contentContainer"}>
            <StatusTab
              isNew={isNew}
              status={status}
              preparedList={preparedList}
              checkedList={checkedList}
              completedList={completedList}
              setStatus={setStatus}
            />
            <div className="orderWrap" onClick={() => setIsOpenBar(false)}>
              {status === 2 && (
                <div className="orderTitle">
                  <button
                    className={`dateButton ${completeStatus === 0 && "active"}`}
                    onClick={() => setCompleteStatus(0)}
                  >
                    전체
                  </button>
                  <button
                    className={`dateButton ${completeStatus === 1 && "active"}`}
                    onClick={() => setCompleteStatus(1)}
                  >
                    완료
                  </button>
                  <button
                    className={`dateButton ${completeStatus === 2 && "active"}`}
                    onClick={() => setCompleteStatus(2)}
                  >
                    취소
                  </button>
                </div>
              )}
              <OrderList
                preparedList={preparedList}
                checkedList={checkedList}
                completedList={completedList}
                status={status}
                completeStatus={completeStatus}
                isDetail={isDetail}
                itemRefs={itemRefs}
              />
            </div>
          </div>
        </div>
      </HomeStyle>
      <RiderProgressModal
        isVisible={visibleRiderProgress}
        setVisible={setVisibleRiderProgress}
      />
      <DeliverySettingModal
        isVisible={visibleDeliverySetting}
        setVisible={setVisibleDeliverySetting}
      />
      <PushSettingModal
        isVisible={visiblePushSetting}
        setVisible={setVisiblePushSetting}
        pushSetting={pushSetting}
        setPushSetting={setPushSetting}
      />
      <ExceedModal
        isVisible={exceed}
        setVisible={setExceed}
        onConfirm={scrollToItem}
      />
    </>
  );
};

export default OrderLinkMain;
